angular.module('impactx.numberingscheme').controller("SecondProcurementGroupCtrl", SecondProcurementGroupCtrl);
SecondProcurementGroupCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    'ToastService',
    'TranslationService',
    'ToolbarService'
];

function SecondProcurementGroupCtrl($scope, dataGen, $routeParams, BackService, ToastService, TranslationService, ToolbarService) {
    var self = this;
    dataGen.getData($scope, {id: $routeParams.id}, "/opengovernmentdata/secondprocurementgroup/view").then(function () {
        $scope.trns.required = TranslationService.get("required");
        $scope.trns.save = TranslationService.get("save");
        defineButtons();
    });

    self.saveSecondProcurementGroupData = function () {
        var dataObj = {
            data: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/opengovernmentdata/secondprocurementgroup/save").then(function () {
            BackService.back();
            ToastService.openStandardToast($scope.trns.saveSuccess);
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.saveSecondProcurementGroupData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}